import React from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { PlusIconWhite, SearchIcon } from "../../components/ui/icons";
import AddEditTemplateModal from "../../components/superAdmin/AddEditTemplateModal";
import { useManageTemplates } from "./useManageTemplates";
import "./manageTemplates.scss";

const ManageTemplates = () => {
  const {
    templates,
    search,
    setSearch,
    visibilityFilter,
    setVisibilityFilter,
    showModal,
    modalMode,
    form,
    setForm,
    handleAddClick,
    handleEditClick,
    handleCloseModal,
    handleSubmit,
    isBusy,
  } = useManageTemplates();

  return (
    <div className="manage-templates-page">
      <div className="manage-templates-heading">
        <h1>Manage Templates</h1>
        <div className="manage-templates-toolbar">
          <InputGroup>
            <Form.Control
              placeholder="Search template"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <InputGroup.Text>
              <SearchIcon />
            </InputGroup.Text>
          </InputGroup>
          <Form.Select
            className="manage-templates-filter"
            value={visibilityFilter}
            onChange={(e) =>
              setVisibilityFilter(e.target.value as "all" | "public" | "private")
            }
          >
            <option value="all">All</option>
            <option value="public">Public</option>
            <option value="private">Private</option>
          </Form.Select>
          <Button className="manage-templates-add-button" onClick={handleAddClick}>
            <PlusIconWhite />
            <span>Add Template</span>
          </Button>
        </div>
      </div>

      <div className="manage-templates-body">
        <Row className="gx-3 gy-3">
          {templates.map((template) => (
            <Col xs={12} sm={6} md={4} lg={3} key={template.templateId}>
              <div className="manage-templates-card">
                <div className="template-assign-image">
                  {template.imageUrl ? (
                    <img src={template.imageUrl} alt={template.name} />
                  ) : (
                    <span>No image</span>
                  )}
                </div>
                <div className="template-assign-label">
                  <div className="name" title={template.name}>
                    {template.name}
                  </div>
                  <div className="visibility">
                    {template.public ? "Public" : "Private"}
                  </div>
                </div>
                <div className="manage-templates-actions">
                  <Button
                    className="btn-style"
                    onClick={() => handleEditClick(template)}
                  >
                    Edit
                  </Button>
                </div>
              </div>
            </Col>
          ))}
          {templates.length === 0 && (
            <div className="template-assign-empty">No templates found</div>
          )}
        </Row>
      </div>

      <AddEditTemplateModal
        show={showModal}
        mode={modalMode}
        form={form}
        setForm={setForm}
        isBusy={isBusy}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default ManageTemplates;
